export let EditorType = /*#__PURE__*/function (EditorType) {
  EditorType["Studio"] = "studio";
  EditorType["Classic"] = "classic";
  EditorType["OdEditor"] = "odeditor";
  return EditorType;
}({});
export let ComponentType = /*#__PURE__*/function (ComponentType) {
  ComponentType["Text"] = "wysiwyg.viewer.components.WRichText";
  ComponentType["Image"] = "wysiwyg.viewer.components.WPhoto";
  ComponentType["VectorImage"] = "wysiwyg.viewer.components.VectorImage";
  ComponentType["ImageX"] = "wixui.ImageX";
  ComponentType["SiteButton"] = "wysiwyg.viewer.components.SiteButton";
  ComponentType["ClassicSection"] = "wysiwyg.viewer.components.ClassicSection";
  ComponentType["ResponsiveSection"] = "responsive.components.Section";
  ComponentType["Page"] = "mobile.core.components.Page";
  ComponentType["MasterPage"] = "mobile.core.components.MasterPage";
  ComponentType["Container"] = "mobile.core.components.Container";
  ComponentType["Column"] = "wysiwyg.viewer.components.Column";
  ComponentType["Group"] = "wysiwyg.viewer.components.Group";
  ComponentType["StylableButton"] = "wixui.StylableButton";
  ComponentType["BoxSlideShow"] = "wysiwyg.viewer.components.BoxSlideShow";
  ComponentType["StripContainerSlideShow"] = "wysiwyg.viewer.components.StripContainerSlideShow";
  ComponentType["BoxSlideShowSlide"] = "wysiwyg.viewer.components.BoxSlideShowSlide";
  ComponentType["StripContainerSlideShowSlide"] = "wysiwyg.viewer.components.StripContainerSlideShowSlide";
  ComponentType["StripColumnsContainer"] = "wysiwyg.viewer.components.StripColumnsContainer";
  ComponentType["PaginatedGridGallery"] = "wysiwyg.viewer.components.PaginatedGridGallery";
  ComponentType["AppWidget"] = "platform.components.AppWidget";
  ComponentType["TpaMultiSection"] = "wysiwyg.viewer.components.tpapps.TPAMultiSection";
  ComponentType["SearchBox"] = "wixui.SearchBox";
  ComponentType["VerticalMenu"] = "wysiwyg.common.components.verticalmenu.viewer.VerticalMenu";
  ComponentType["HorizontalMenu"] = "wixui.StylableHorizontalMenu";
  ComponentType["DropdownMenu"] = "wysiwyg.viewer.components.menus.DropDownMenu";
  ComponentType["Menu"] = "wixui.Menu";
  ComponentType["MegaMenu"] = "wixui.MegaMenuContainerItem";
  ComponentType["SubMenu"] = "wixui.Submenu";
  ComponentType["Breadcrumbs"] = "wixui.Breadcrumbs";
  ComponentType["StateBox"] = "wysiwyg.viewer.components.StateBox";
  ComponentType["StateBoxState"] = "wysiwyg.viewer.components.StateBoxState";
  ComponentType["HeaderContainer"] = "wysiwyg.viewer.components.HeaderContainer";
  ComponentType["ResponsiveHeader"] = "responsive.components.HeaderSection";
  ComponentType["FooterContainer"] = "wysiwyg.viewer.components.FooterContainer";
  ComponentType["ResponsiveFooter"] = "responsive.components.FooterSection";
  ComponentType["Repeater"] = "wysiwyg.viewer.components.Repeater";
  ComponentType["TpaWidget"] = "wysiwyg.viewer.components.tpapps.TPAWidget";
  ComponentType["VideoPlayer"] = "wixui.VideoPlayer";
  ComponentType["MediaPlayer"] = "wysiwyg.viewer.components.MediaPlayer";
  ComponentType["MusicPlayer"] = "wixui.MusicPlayer";
  ComponentType["AudioPlayer"] = "wysiwyg.viewer.components.AudioPlayer";
  ComponentType["SingleAudioPlayer"] = "wysiwyg.common.components.singleaudioplayer.viewer.SingleAudioPlayer";
  ComponentType["SpotifyPlayer"] = "wysiwyg.common.components.spotifyplayer.viewer.SpotifyPlayer";
  ComponentType["Video"] = "wysiwyg.viewer.components.Video";
  ComponentType["Section"] = "responsive.components.Section";
  ComponentType["TextMarquee"] = "wixui.TextMarquee";
  ComponentType["LinkBar"] = "wysiwyg.viewer.components.LinkBar";
  ComponentType["ProgressBar"] = "wixui.ProgressBar";
  ComponentType["Pagination"] = "wixui.Pagination";
  ComponentType["TextAreaInput"] = "wysiwyg.viewer.components.inputs.TextAreaInput";
  ComponentType["FiveGridLine"] = "wysiwyg.viewer.components.FiveGridLine";
  ComponentType["PopupContainer"] = "wysiwyg.viewer.components.PopupContainer";
  ComponentType["PopupCloseIconButton"] = "wysiwyg.viewer.components.PopupCloseIconButton";
  ComponentType["MediaContainer"] = "wysiwyg.viewer.components.MediaContainer";
  ComponentType["TextInput"] = "wysiwyg.viewer.components.inputs.TextInput";
  ComponentType["ComboBoxInput"] = "wysiwyg.viewer.components.inputs.ComboBoxInput";
  ComponentType["GoogleMap"] = "wysiwyg.viewer.components.GoogleMap";
  ComponentType["VerticalLine"] = "wysiwyg.viewer.components.VerticalLine";
  ComponentType["Anchor"] = "wysiwyg.common.components.verticalanchorsmenu.viewer.VerticalAnchorsMenu";
  ComponentType["HtmlComponent"] = "wysiwyg.viewer.components.HtmlComponent";
  ComponentType["TpaSection"] = "wysiwyg.viewer.components.tpapps.TPASection";
  ComponentType["SlideShowGallery"] = "wysiwyg.viewer.components.SlideShowGallery";
  ComponentType["TextMask"] = "wixui.TextMask";
  ComponentType["TextEffectsShook"] = "wixui.TextEffectsShook";
  ComponentType["TextEffectsSticker"] = "wixui.TextEffectsSticker";
  ComponentType["TextEffectsMatrix"] = "wixui.TextEffectsMatrix";
  ComponentType["TextEffectsRetro"] = "wixui.TextEffectsRetro";
  ComponentType["TextEffectsBauhaus"] = "wixui.TextEffectsBauhaus";
  ComponentType["TextEffectsOutlineOut"] = "wixui.TextEffectsOutlineOut";
  ComponentType["TextEffectsStriped"] = "wixui.TextEffectsStriped";
  ComponentType["TextEffectsLetterPress"] = "wixui.TextEffectsLetterPress";
  ComponentType["TextEffects3d"] = "wixui.TextEffects3d";
  ComponentType["TextEffectsGlass"] = "wixui.TextEffectsGlass";
  ComponentType["TextEffectsGlitch"] = "wixui.TextEffectsGlitch";
  ComponentType["TextEffectsNeonSign"] = "wixui.TextEffectsNeonSign";
  ComponentType["TextEffectsNoisy"] = "wixui.TextEffectsNoisy";
  ComponentType["FooterSection"] = "responsive.components.FooterSection";
  ComponentType["HeaderSection"] = "responsive.components.HeaderSection";
  ComponentType["HamburgerMenuRoot"] = "wixui.HamburgerMenuRoot";
  ComponentType["RefComponent"] = "wysiwyg.viewer.components.RefComponent";
  ComponentType["Tabs"] = "wixui.Tabs";
  // Inaccessible components types
  ComponentType["Accordion"] = "tpa.viewer.components.Accordion";
  ComponentType["AdminLoginButton"] = "wysiwyg.viewer.components.AdminLoginButton";
  ComponentType["BgImageStrip"] = "wysiwyg.viewer.components.BgImageStrip";
  ComponentType["Collage"] = "tpa.viewer.components.Collage";
  ComponentType["FlickrBadgeWidget"] = "wysiwyg.viewer.components.FlickrBadgeWidget";
  ComponentType["FormContainer"] = "wysiwyg.viewer.components.FormContainer";
  ComponentType["Freestyle"] = "tpa.viewer.components.Freestyle";
  ComponentType["Honeycomb"] = "tpa.viewer.components.Honeycomb";
  ComponentType["Impress"] = "tpa.viewer.components.Impress";
  ComponentType["ItunesButton"] = "wysiwyg.viewer.components.ItunesButton";
  ComponentType["LineShareButton"] = "wixui.LineShareButton";
  ComponentType["LoginButton"] = "wysiwyg.viewer.components.LoginButton";
  ComponentType["Masonry"] = "tpa.viewer.components.Masonry";
  ComponentType["MatrixGallery"] = "wysiwyg.viewer.components.MatrixGallery";
  ComponentType["PinItPinWidget"] = "wysiwyg.common.components.pinitpinwidget.viewer.PinItPinWidget";
  ComponentType["PinterestFollow"] = "wysiwyg.viewer.components.PinterestFollow";
  ComponentType["PinterestPinIt"] = "wysiwyg.common.components.pinterestpinit.viewer.PinterestPinIt";
  ComponentType["RSSButton"] = "wysiwyg.common.components.rssbutton.viewer.RSSButton";
  ComponentType["SkypeCallButton"] = "wysiwyg.common.components.skypecallbutton.viewer.SkypeCallButton";
  ComponentType["SliderGallery"] = "wysiwyg.viewer.components.SliderGallery";
  ComponentType["SoundCloudWidget"] = "wysiwyg.viewer.components.SoundCloudWidget";
  ComponentType["SpotifyFollow"] = "wysiwyg.common.components.spotifyfollow.viewer.SpotifyFollow";
  ComponentType["StripShowcase"] = "tpa.viewer.components.StripShowcase";
  ComponentType["StripSlideshow"] = "tpa.viewer.components.StripSlideshow";
  ComponentType["TPA3DCarousel"] = "wysiwyg.viewer.components.tpapps.TPA3DCarousel";
  ComponentType["TPA3DGallery"] = "wysiwyg.viewer.components.tpapps.TPA3DGallery";
  ComponentType["Thumbnails"] = "tpa.viewer.components.Thumbnails";
  ComponentType["TwitterFeed"] = "wysiwyg.viewer.components.TwitterFeed";
  ComponentType["VKShareButton"] = "wysiwyg.viewer.components.VKShareButton";
  ComponentType["WFacebookComment"] = "wysiwyg.viewer.components.WFacebookComment";
  ComponentType["WTwitterFollow"] = "wysiwyg.viewer.components.WTwitterFollow";
  ComponentType["WTwitterTweet"] = "wysiwyg.viewer.components.WTwitterTweet";
  ComponentType["YouTubeSubscribeButton"] = "wysiwyg.common.components.youtubesubscribebutton.viewer.YouTubeSubscribeButton";
  ComponentType["BuilderImage"] = "Builder.Image";
  return ComponentType;
}({});
export let ComponentBackgroundType = /*#__PURE__*/function (ComponentBackgroundType) {
  ComponentBackgroundType["SolidColor"] = "SOLID_COLOR";
  ComponentBackgroundType["Gradient"] = "GRADIENT";
  ComponentBackgroundType["Media"] = "MEDIA";
  ComponentBackgroundType["MultipleColors"] = "MULTIPLE_COLORS";
  ComponentBackgroundType["Transparent"] = "TRANSPARENT";
  return ComponentBackgroundType;
}({});
//# sourceMappingURL=types.js.map